import axios from '@p/utils/request';
import api from '@/api';
import storage from '@/utils/storage'

// 所有考试列表
export const lists = (data) => {
	return axios.get(api.examination.lists,{params:data})
}

// 考试试卷列表
export const examPaper = (data) => {
	return axios.get(api.examination.examPaper,{params:data})
}

// 试卷详情
export const show = (data) => {
	return axios.get(api.examination.show,{params:data})
}

// 提交试卷
export const save = (data) => {
	return axios.post(api.examination.save,data)
}

// 我的考试成绩列表
export const achievement = (data) => {
	return axios.get(api.examination.achievement,{params:data})
}

// 我的考试成绩详情
export const achievementArchives = (data) => {
	return axios.get(api.examination.achievementArchives,{params:data})
}

// 试卷成绩列表
export const achievementList = (data) => {
	return axios.get(api.examination.achievementList,{params:data})
}
